import {Box, Skeleton, SkeletonText, VStack} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';

export const ProductSkeleton: FC = () => {
  return (
    <VStack
      alignItems="stretch"
      cursor="pointer"
      bg={colors.white}
      borderRadius="16px"
      p={['12px', '15px']}
      position="relative"
    >
      <Box minH={['140px', '214px']} objectFit="cover">
        <Skeleton h="180px" mb="12px" borderRadius="16px" />
        <SkeletonText skeletonHeight="20px" pb="12px" w="60%" noOfLines={1} mb="8px" />
        <SkeletonText skeletonHeight="10px" w="100%" noOfLines={1} mb="12px" />
        <SkeletonText skeletonHeight="10px" w="100%" noOfLines={1} mb="12px" />
        <Skeleton width="100%" height="46px" borderRadius="16px" />
      </Box>
    </VStack>
  );
};
